import {
  Link,
  SummaryCard,
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from "@certn/cascadia-react";
import { CascadiaJsonFormContext, withCascadiaLayoutProps } from "@certn/forms";
import { slugify } from "@certn/utils";
import { LayoutProps, isCategorization } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { useContext } from "react";
import { Trans } from "react-i18next";

import { useApplicationFormContext } from "../ApplicationFormContext";
import { ApplicationContext } from "../ApplicationContext";
import { groupSectionsByGroupId } from "../utils";

export function CategorizationLayout(props: LayoutProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { uischema } = props;
  const { caseId } = useApplicationFormContext();
  const { basePath = "apply" } = useContext(ApplicationContext) || {};
  const testID = `form-categorization-tabs-${slugify(props.label)}`;

  const { readonly } = useContext(CascadiaJsonFormContext);

  if (!isCategorization(uischema)) {
    return null;
  }

  if (isSummaryForPath?.(props.path)) {
    const groups = groupSectionsByGroupId(
      uischema.elements.map((el) => el as typeof el & { name: string })
    );

    return (
      <>
        {groups.map((group) => {
          const firstCategory = group.sections[0];
          const hasSummary = group.sections.some(
            (s) => s.type === "Category" && s.options?.include_summary
          );

          if (group.sections.length > 1 && hasSummary) {
            return (
              <SummaryCard
                key={group.groupId ?? slugify(firstCategory.label)}
                header={firstCategory.label}
                testID={`${testID}-${slugify(firstCategory.label)}-summary`}
                actions={
                  !readonly && (
                    <Link
                      href={`/${basePath}/${caseId}/${slugify(firstCategory.name)}`}
                      linkStyle="monochrome"
                      textColor="text-weak"
                      testID={`${slugify(firstCategory.label)}-summary-edit-button`}
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  )
                }
              >
                {group.sections.map((section) => (
                  <JsonFormsDispatch
                    key={section.name}
                    schema={props.schema}
                    uischema={section}
                  />
                ))}
              </SummaryCard>
            );
          }

          return group.sections.map((category, index) => {
            if (
              category.type === "Category" &&
              category.options?.include_summary
            ) {
              return (
                <SummaryCard
                  key={`${slugify(category.label)}-${index}`}
                  header={category.label}
                  testID={`${testID}-${slugify(category.label)}-summary`}
                  actions={
                    !readonly && (
                      <Link
                        href={`/${basePath}/${caseId}/${slugify(category.name)}`}
                        linkStyle="monochrome"
                        textColor="text-weak"
                        testID={`${slugify(category.label)}-summary-edit-button`}
                      >
                        <Trans>Edit</Trans>
                      </Link>
                    )
                  }
                >
                  <JsonFormsDispatch
                    schema={props.schema}
                    uischema={category}
                  />
                </SummaryCard>
              );
            }

            return (
              <JsonFormsDispatch
                key={`${category.label}-${index}`}
                schema={props.schema}
                uischema={category}
              />
            );
          });
        })}
      </>
    );
  }

  return (
    <Tabs testID={testID}>
      <TabList>
        {uischema.elements.map((category, index) => (
          <Tab
            id={String(index)}
            key={`${testID}-${slugify(category.label)}-tab`}
            testID={`${testID}-${slugify(category.label)}-tab`}
          >
            {category.label}
          </Tab>
        ))}
      </TabList>
      {uischema.elements.map((category, index) => (
        <TabPanel
          id={String(index)}
          key={`${testID}-${slugify(category.label)}-tabpanel`}
        >
          <JsonFormsDispatch schema={props.schema} uischema={category} />
        </TabPanel>
      ))}
    </Tabs>
  );
}

export const CategorizationLayoutRenderer =
  withCascadiaLayoutProps(CategorizationLayout);
